import { render, staticRenderFns } from "./CollapseButton.vue?vue&type=template&id=f0e71724&scoped=true"
import script from "./CollapseButton.vue?vue&type=script&lang=js"
export * from "./CollapseButton.vue?vue&type=script&lang=js"
import style0 from "./CollapseButton.vue?vue&type=style&index=0&id=f0e71724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e71724",
  null
  
)

export default component.exports